<template>
  <div v-if="clientPortal != null" id="show-client-portal-banner-footer">
    <div>
      <v-dialog v-model="dialogForBannerFooter" persistent max-width="300">
        <template v-slot:activator="{ on }" class="d-flex">
          <v-btn v-if="isGrantedUser()" v-on="on" text :loading="loading">
            <v-icon left>mdi-upload</v-icon>
            Charger
          </v-btn>
          <v-btn
            v-if="isGrantedUser()"
            :disabled="!hasResource"
            text
            @click="openDeleteDialog(clientPortal)"
            :loading="loading"
          >
            <v-icon left>mdi-delete</v-icon>
            Supprimer
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary-background">
            <span
              >Chargement du
              {{ type === "banner" ? "bandeau" : "footer" }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="bannerFooterFormRef" v-model="isFormValid">
              <v-file-input
                :rules="bannerFooter_fileRules"
                v-model="bannerFooterFile"
                :label="type === 'banner' ? 'Bandeau' : 'Footer'"
                accept=".jpg, .png, .svg"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogForBannerFooter = false">
              Fermer
            </v-btn>
            <v-btn
              color="primary"
              @click="triggerUploadBannerFooter"
              :loading="uploadLoading"
              :disabled="!isFormValid"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <delete-dialog
      :open.sync="deleteDialog"
      v-on:delete="triggerRemoveBannerFooter"
    >
      <template #title>
        Suppression du {{ type === "banner" ? "bandeau" : "footer" }} pour
        {{ clientPortal.description }}
      </template>
      Vous êtes sur le point de supprimer le
      {{ type === "banner" ? "bandeau" : "footer" }} de ce portail. Voulez-vous
      continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { useClientPortalBannerFooter } from "../../composables/client-portal-banner-footer";
import { toRefs, computed, ref } from "@vue/composition-api";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
    type: String,
  },
  components: {
    DeleteDialog,
  },
  setup(props, { emit }) {
    const {
      clientPortalBannerFooterData,
      uploadBannerFooter,
      removeBannerFooter,
    } = useClientPortalBannerFooter();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const loading = ref(false);
    const errorMessage = ref("");
    const uploadLoading = ref(false);
    const isFormValid = ref(false);

    /* Computed */
    const hasResource = computed(function () {
      if (props.type === "banner") {
        return props.clientPortal.bannerPath.indexOf("/banner") > -1;
      } else {
        return props.clientPortal.footerPath.indexOf("/footer") > -1;
      }
    });

    /* Méthodes */
    const openDeleteDialog = function (portal) {
      clientPortalBannerFooterData.deleteDialog = true;
      clientPortalBannerFooterData.editedItem = { ...portal };
    };
    const closeDeleteDialog = function () {
      clientPortalBannerFooterData.deleteDialog = false;
      clientPortalBannerFooterData.editedItem = null;
    };
    const triggerRemoveBannerFooter = async function () {
      loading.value = true;
      await removeBannerFooter(
        clientPortalBannerFooterData.editedItem.id,
        props.type
      );
      loading.value = false;
      closeDeleteDialog();
      emit("refresh-preview");
    };
    const triggerUploadBannerFooter = async function () {
      loading.value = true;
      uploadLoading.value = true;
      await uploadBannerFooter(props.clientPortal.id, props.type);
      loading.value = false;
      uploadLoading.value = false;
      if (!clientPortalBannerFooterData.uploadError) {
        clientPortalBannerFooterData.dialogForBannerFooter = false;
        emit("refresh-preview");
      }
    };

    return {
      uploadBannerFooter,
      openDeleteDialog,
      triggerRemoveBannerFooter,
      hasResource,
      ...toRefs(clientPortalBannerFooterData),
      triggerUploadBannerFooter,
      loading,
      errorMessage,
      uploadLoading,
      isGrantedUser,
      isFormValid,
    };
  },
};
</script>
